export var MAX_TEXTURES = 10;
export var MAX_POINT_LIGHTS = 4;
export var PICKING_RES = 4;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JlL2NvbmZpZy5qcyJdLCJuYW1lcyI6WyJNQVhfVEVYVFVSRVMiLCJNQVhfUE9JTlRfTElHSFRTIiwiUElDS0lOR19SRVMiXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sSUFBTUEsZUFBZSxFQUFyQjtBQUNQLE9BQU8sSUFBTUMsbUJBQW1CLENBQXpCO0FBQ1AsT0FBTyxJQUFNQyxjQUFjLENBQXBCIiwiZmlsZSI6ImNvbmZpZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBNQVhfVEVYVFVSRVMgPSAxMDtcbmV4cG9ydCBjb25zdCBNQVhfUE9JTlRfTElHSFRTID0gNDtcbmV4cG9ydCBjb25zdCBQSUNLSU5HX1JFUyA9IDQ7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/core/config.js
// module id = 548
// module chunks = 0